import {isArray} from "chart.js/helpers";
import {restApi} from "./RestApiMixin.js";

export const workAssignmentGeomTypes = {
    POINT: 1,
    LINESTRING: 2,
    POLYGON: 3
}

export const workAssignmentHelper = {
    mixins: [restApi],
    data: function () {
        return {
            OPEN: 1,
            IN_PROGRESS: 2,
            ASSIGNED: 3,
            COMPLETED: 10,
            CANCELLED: 20,
            ARCHIVED: 30,
            AREA_DEFECT: 1,
            VEHICLE_DEFECT: 2,
            OBSERVATION: 3,
            WORK_DEFECT: 5,
            LOW: 1,
            NORMAL: 2,
            HIGH: 3
        }
    },
    methods: {
        getStatusColor(status) {
            switch (status) {
                case this.OPEN: return '#00eaff'
                case this.ASSIGNED: return '#1a6fb9'
                case this.IN_PROGRESS: return '#faa633'
                case this.COMPLETED: return '#337003'
                case this.CANCELLED: return '#e14343'
            }
            return '#bcbcbc'
        },
        getAssignmentInfo(item) {
            let info = ''
            if (item.observation && item.observation.info) {
                info = item.observation.info
            }
            if (item.info) {
                if (info.length > 0 && !info.endsWith('.')) {
                    info += '. '
                }
                info += item.info
            }
            return info
        },
        getTitle: function (item) {
            if (item.area_defect) {
                return this.getAreaDefectInfo(item.area_defect)
            }
            if (item.vehicle_defect) {
                return this.getVehicleInfo(item.vehicle_defect)
            }
            if (item.observation) {
                return this.getObservationInfo(item.observation)
            }
            if (item.work_order) {
                return item.work_order.task_type.name
            }
            if (item.contract) {
                return this.getContractInfo(item.contract)
            }
            if (item.info) {
                return item.info.length < 15 ? item.info : item.info.substring(0, 15) + "..."
            }
            return '-';
        },

        getAreaDefectInfo: function (areaDefect) {
            if (areaDefect && areaDefect.area && areaDefect.area_equipment) {
                return areaDefect.area.name + ' - ' + areaDefect.area_equipment.name
            } else {
                return ''
            }
        },
        getVehicleInfo: function (vehicleDefect) {
            if (vehicleDefect) {
                return vehicleDefect.vehicle.license_plate + ' - ' + vehicleDefect.description
            } else {
                return ''
            }
        },
        getObservationInfo: function (observation) {
            if (observation) {
                return (observation.type_name || observation.type.name)
            } else {
                return ''
            }
        },
        getContractInfo: function (contract) {
            if (contract) {
                return contract.name + " (" + contract.customer.name + " - " + contract.contractor.name + ")"
            } else {
                return ''
            }
        },

        getWorkAssignmentLatLon(workAssignment){
            const pos = this.getWorkAssignmentPointPosition(workAssignment)
            if (pos) {
                return {
                    lat: pos.y,
                    lon: pos.x
                }
            }
            return null
        },


        getWorkAssignmentPointPosition(workAssignment){
            let markerPosition = null
            if (workAssignment.geometry) {
                if (workAssignment.geometry.polygon) {
                    const rings = workAssignment.geometry.polygon.rings
                    if (isArray(rings[0][0])) {
                        markerPosition = {
                            'x': workAssignment.geometry.polygon.rings[0][0][0],
                            'y': workAssignment.geometry.polygon.rings[0][0][1]
                        }
                    } else {
                        markerPosition = {
                            'x': workAssignment.geometry.polygon.rings[0][0],
                            'y': workAssignment.geometry.polygon.rings[0][1]
                        }
                    }
                    return markerPosition
                } else if (workAssignment.geometry.point) {
                    markerPosition = workAssignment.geometry.point
                } else if (workAssignment.geometry.line_string) {
                    markerPosition = {
                        'x': workAssignment.geometry.line_string.points[0][0],
                        'y': workAssignment.geometry.line_string.points[0][1]
                    }
                }
            } else if (workAssignment.position) {
                markerPosition = workAssignment.position
            } else if (workAssignment.observation && workAssignment.observation.geometry &&  workAssignment.observation.geometry.point) {
                markerPosition = workAssignment.observation.geometry.point
            } else if (workAssignment.observation && workAssignment.observation.geometry && workAssignment.observation.geometry.line_string){
                let geometry = workAssignment.observation.geometry.line_string
                markerPosition = {'x': geometry.points[0][0], 'y': geometry.points[0][1]}
            } else if (workAssignment.area_defect?.area_equipment?.location){
                markerPosition = workAssignment.area_defect.area_equipment.location
            } else if(workAssignment.area_equipment && workAssignment.area_equipment.location){
                markerPosition = workAssignment.area_equipment.location
            }
            // Convert to xy
            if (markerPosition && markerPosition.lat) {
                markerPosition = {x: markerPosition.lon, y: markerPosition.lat}
            }
            return markerPosition
        },
        getWorkAssignmentGeometryType(workAssignment) {
            if(workAssignment) {
                if(workAssignment.geometry && workAssignment.geometry.point) {
                    return workAssignmentGeomTypes.POINT;
                } else if(workAssignment.geometry && workAssignment.geometry.line_string) {
                    return workAssignmentGeomTypes.LINESTRING;
                } else if(workAssignment.geometry && workAssignment.geometry.polygon) {
                    return workAssignmentGeomTypes.POLYGON
                } else if(workAssignment.position) {
                    return workAssignmentGeomTypes.POINT;
                }
            }
            return null
        },
        newWorkAssignment: function (like) {
            const deepCloned = JSON.parse(JSON.stringify(like))
            return {
                id: -1,
                assigned_to: null,
                assigned_company: {id: null},
                status: 1,
                priority_value: 2,
                info: '',
                observation: null,
                vehicle_defect: null,
                area_defect: null,
                progress_value: like ? like.progress_value ? like.progress_value : like.status === 10 ? 100 : 0 : 0,
                contract: like && like.contract ? like.contract : {id: null},
                work_order: like && like.work_order ? like.work_order : {id: null},
                email: '',
                external_tasks: [],
                ...deepCloned
            }
        },
        getStatus: function (isNewAssignment) {
            if (isNewAssignment) {
                return [
                    {key: this.$t('work_assignment.open'), status: this.OPEN},
                    {key: this.$t('work_assignment.assigned'), status: this.ASSIGNED},
                    {key: this.$t('work_assignment.in_progress'), status: this.IN_PROGRESS}
                ]
            } else {
                return [
                    {key: this.$t('work_assignment.open'), status: this.OPEN},
                    {key: this.$t('work_assignment.assigned'), status: this.ASSIGNED},
                    {key: this.$t('work_assignment.in_progress'), status: this.IN_PROGRESS},
                    {key: this.$t('work_assignment.completed'), status: this.COMPLETED},
                    {key: this.$t('work_assignment.cancelled'), status: this.CANCELLED}
                ]
            }
        },

        getStatusString: function (status) {
            switch (status) {
                case this.OPEN:
                    return this.$t('work_assignment.open')
                case this.ASSIGNED:
                    return this.$t('work_assignment.assigned')
                case this.IN_PROGRESS:
                    return this.$t('work_assignment.in_progress')
                case this.COMPLETED:
                    return this.$t('work_assignment.completed')
                case this.CANCELLED:
                    return this.$t('work_assignment.cancelled')
                case this.ARCHIVED:
                    return this.$t('observation_list.archived')
            }
        },

        getPriority: function () {
            return [
                {key: this.$t('work_assignment.low'), priorityValue: this.LOW},
                {key: this.$t('work_assignment.normal'), priorityValue: this.NORMAL},
                {key: this.$t('work_assignment.high'), priorityValue: this.HIGH}
            ]
        },

        getPriorityString: function (priority) {
            switch (priority) {
                case this.LOW:
                    return this.$t('work_assignment.low')
                case this.NORMAL:
                    return this.$t('work_assignment.normal')
                case this.HIGH:
                    return this.$t('work_assignment.high')
            }
        },

        jsonToWorkAssignment: function (assignment) {
            let copy = JSON.parse(JSON.stringify(assignment))
            if (!copy.assigned_to) {
                copy.assigned_to = null
            }
            return copy
        },
        handleContractResults: function (response) {
            if(typeof this.loading === 'boolean') {
                this.loading = false
            } else {
                this.loading--
            }
            if (response != null) {
                this.contracts = response.data
            }
        },
        fetchOpenContracts: function () {
            this.contracts = []
            if(typeof this.loading === 'boolean') {
                this.loading = true
            } else {
                this.loading++
            }
            let today = new Date()
            let params = {
                startDate: this.localTimeToUtcTime(today).toISOString(),
                endDate: this.getEndOfTheDay(today).toISOString()
            }
            this.restFetchParams(this.contractOpenUrl, params, this.handleContractResults)
        },

        getAssignmentPhotos(assignment, commentPhotos) {
            let temp = []
            const observation = assignment.observation
            // Observation photos
            if (observation && observation.photos) {
                observation.photos.forEach(photo => temp.push({url: this.observationPhotoUrl + '/' + observation.id + '/' + photo.id}))
            }
            // Comment photos
            if (commentPhotos) {
                commentPhotos.forEach(photo => temp.push({src: photo}))
            }
            // Area defect photos
            if (assignment.area_defect && assignment.area_defect.photo && assignment.area_defect.report) {
                assignment.area_defect.photos.forEach(photo => temp.push({
                    url: this.areaReportPhotoUrl + assignment.area_defect.report + '/' + photo.id}))
            }

            // Area equipment photos
            const areaEquipment = assignment.area_equipment ? assignment.area_equipment :
                assignment.area_defect?.area_equipment
            if (areaEquipment && areaEquipment.photos) {
                areaEquipment.photos.forEach(photo => temp.push({url: this.areaEquipmentPhotoUrl + areaEquipment.id + '/' + photo.id}))
            }

            // Vehicle defect photos - TODO
            if (assignment.vehicle_defect && assignment.vehicle_defect.photo && this.assignment.vehicle_defect.report) {
                assignment.vehicle_defect.photos.forEach(photo => temp.push({
                    url: this.inspectionPhotoUrl + assignment.vehcle_defect.report + '/' + photo.id}))
            }

            // Vehicle photos
            const vehicle = assignment.vehicle_defect?.vehicle
            if (vehicle && vehicle.photos) {
                vehicle.photos.forEach(photo => temp.push({url: this.vehicleUrl + '/photo/' + vehicle.id + '/' + photo.id}))
            }

            // TODO - Work inspection defect photos

            return temp
        },

        statusClass(statusCode) {
            switch (statusCode) {
                case this.OPEN:
                    return 'status-badge-rounded status-new'
                case this.ASSIGNED:
                    return 'status-badge-rounded status-assigned'
                case this.IN_PROGRESS:
                    return 'status-badge-rounded status-in-progress'
                case this.COMPLETED:
                    return 'status-badge-rounded status-paid'
                case this.CANCELLED:
                    return 'status-badge-rounded status-failed'
                default:
                    return 'status-badge-rounded status-default'
            }
        },

        priorityClass(statusCode) {
            switch (statusCode) {
                case this.NORMAL:
                    return 'status-badge status-normal'
                case this.HIGH:
                    return 'status-badge status-failed'
                default:
                    return 'status-badge status-default'
            }
        },

    }
}
